import { LoadingIcon } from "melco-ui";
//import { useTranslation } from "react-i18next";
import { useAddSupplier } from "../../hooks/suppliers/useAddSupplier";
import { HOOPS } from "../../helper/suppliers";



type AddHoopsSupplierProps = {

  setIsAddHoopsSupplierDrawerOpenAction: (v: boolean, id: string) => void
};

export const AddHoopsSupplier: React.FC<
  AddHoopsSupplierProps
> = ({ setIsAddHoopsSupplierDrawerOpenAction }) => {
  const [addSupplier, isLoading] = useAddSupplier(HOOPS);

  //  const { t } = useTranslation();
  return (
    <>
      {
        <div
          key="add-hoops-suppliers"
          //  type="primary"
          // icon={<PlusIcon />}
          onClick={async () => {
            const supplier = await addSupplier();
            if (supplier) {

              setIsAddHoopsSupplierDrawerOpenAction(true, supplier.id);
            }
          }}
        //loading={isLoading}
        >
          {/* {t("managesuppliers.actions.add..hoops")} */}
          {isLoading && <LoadingIcon />} Hoops
        </div>
      }
    </>


  );
};
